import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

// ********************* Updates ***************************
const buildUpdatePolicy = function(errorHandler) {
	return async function({ policyId, endorsementId, input, store }) {
		const query = gql`
			mutation updatePolicy2(
				$policyId: String!
				$endorsementId: String
				$input: updatePolicyInput!
			) {
				updatePolicy2(
					policyId: $policyId
					endorsementId: $endorsementId
					input: $input
				) {
					createdStatus {
						id
					}
					errors
					status
				}
			}
		`
		const variables = { policyId, endorsementId, input }
		const res = await api({ query, variables })
		errorHandler(res?.errors, res?.data?.updatePolicy2, store)
		return {
			status: res?.data?.updatePolicy2?.status,
			id: res?.data?.updatePolicy2?.createdStatus?.id
		}
	}
}

const buildUpdatePolicyFact = function(errorHandler) {
	return async function({ policyId, endorsementId, factId, input, store }) {
		const query = gql`
			mutation updatePolicyFact(
				$policyId: String!
				$endorsementId: String
				$factId: String!
				$input: updateFactInput!
			) {
				updatePolicyFact(
					policyId: $policyId
					endorsementId: $endorsementId
					factId: $factId
					input: $input
				) {
					createdStatus {
						id
					}
					errors
					status
				}
			}
		`
		const variables = { policyId, endorsementId, factId, input }
		const res = await api({ query, variables })
		errorHandler(res?.errors, res?.data?.updatePolicyFact, store)
		return {
			status: res?.data?.updatePolicyFact?.status,
			id: res?.data?.updatePolicyFact?.createdStatus?.id
		}
	}
}

// ************************** Add ***************************
const buildAddPolicyFact = function(errorHandler) {
	return async function({ policyId, endorsementId, input, store }) {
		const query = gql`
			mutation addPolicyFact(
				$policyId: String!
				$endorsementId: String
				$input: addFactInput!
			) {
				addPolicyFact(
					policyId: $policyId
					endorsementId: $endorsementId
					input: $input
				) {
					createdStatus {
						id
					}
					errors
					status
				}
			}
		`
		const variables = { policyId, endorsementId, input }
		const res = await api({ query, variables })
		errorHandler(res?.errors, res?.data?.addPolicyFact, store)
		return {
			status: res?.data?.addPolicyFact?.status,
			id: res?.data?.addPolicyFact?.createdStatus?.id
		}
	}
}

// ************************** Remove ***************************
const buildRemovePolicyFact = function(errorHandler) {
	return async function({ policyId, endorsementId, factId, store }) {
		const query = gql`
			mutation removePolicyFact(
				$policyId: String!
				$endorsementId: String
				$factId: String!
			) {
				removePolicyFact(
					policyId: $policyId
					endorsementId: $endorsementId
					factId: $factId
				) {
					createdStatus {
						id
					}
					errors
					status
				}
			}
		`
		const variables = { policyId, endorsementId, factId }
		const res = await api({ query, variables })
		errorHandler(res?.errors, res?.data?.removePolicyFact, store)
		return {
			status: res?.data?.removePolicyFact?.status,
			id: res?.data?.removePolicyFact?.createdStatus?.id
		}
	}
}

export {
	buildUpdatePolicyFact,
	buildAddPolicyFact,
	buildRemovePolicyFact,
	buildUpdatePolicy
}
